"use client";
import React from "react";
import { Nft } from "@/api/nfts/types";
import { AuctionCountdown } from "../TradeCountdown";
import { TradeDetails } from "../TradeDetails";
import { PriceHistory } from "../PriceHistory";
import { useQuery } from "@tanstack/react-query";
import ordersApi from "@/api/orders/client";
import { ReserveActivityTable } from "../ReserveActivityTable";
import nftsApi from "@/api/nfts/client";
import usersApi from "@/api/users/client";

export interface Props {
  nftId: string;
}

export default function NftTrade({ nftId }: Props) {
  const { data: nft } = useQuery({
    queryKey: ["nft", nftId],
    queryFn: async () => {
      const nftItem = await nftsApi.getSingleNft(nftId);

      const [nft] = await usersApi.enrichWithUser<Nft, "artist">([nftItem], {
        artist: true,
      });

      return nft;
    },
  });

  const { data: orders } = useQuery({
    queryKey: ["orders-for-nft", nftId],
    queryFn: () => ordersApi.getOrdersForNft(nftId),
  });

  const auction = orders.auction || orders.privateAuction || null;

  return (
    <div className="pt-20">
      <div className="relative">
        <AuctionCountdown auction={orders.auction} />
        <TradeDetails nft={nft!} auction={auction} offers={orders.offers} />
        <ReserveActivityTable nft={nft!} auction={orders.auction} />
        <PriceHistory nft={nft!} />
      </div>
    </div>
  );
}
